<ng-container *ngIf="formFactoryField$ | async as formFactoryFieldRef">
    <mat-label *ngIf="formFactoryFieldRef.label">{{ formFactoryFieldRef.label }}</mat-label>
    <mga-accountmanager-selector
        [formControl]="formFactoryFieldRef.formControl"
        [allowClear]="true"
    ></mga-accountmanager-selector>
</ng-container>
